// src/pages/Dashboard.js
import React from "react";
import { Box } from "@mui/material";
import Sidenav from "../examples/Sidenav";
import Topbar from "../components/Topbar";
import EventList from "../components/EventList";
import MapComponent from "../components/MapComponent";
import routes from "../routes";

function Dashboard() {
  return (
    <Box sx={{ display: "flex", backgroundColor: "#1A2035", minHeight: "100vh", p: 2 }}>
      <Sidenav brandName="SafeAlert" routes={routes} />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Topbar />
        <Box sx={{ display: "flex", flex: 1, gap: 2, mt: 2 }}>
          <Box sx={{ flex: 1 }}>
            <EventList />
          </Box>
          <Box sx={{ flex: 1, backgroundColor: "#fff", borderRadius: "10px", p: 2, height: 500 }}>
            <MapComponent />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Dashboard;
